import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <Box
      sx={{
        background: "#f5f5f5",
        padding: "10px 0",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2" sx={{ color: "gray", ml: 5 }}>
          @Copyright 2024, All Rights Reserved{" "}
          <span style={{ color: "black", fontWeight: "bold" }}>
            Powered by @techHabiles
          </span>
        </Typography>
        <Typography variant="body2">
          <Link style={{ color: "blue", textDecoration: "none", mr: 5 }}>
            Terms & Conditions | Privacy Policy
          </Link>
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
